// All date formatting uses the Argentina/Ushuaia timezone and es-AR locale.
const TZ = "America/Argentina/Ushuaia";
const LOCALE = "es-AR";

const MONTHS = [
  "enero", "febrero", "marzo", "abril", "mayo", "junio",
  "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre",
];
const WEEKDAYS = [
  "domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado",
];

function parseDate(input) {
  if (!input) return null;
  if (input instanceof Date) return input;
  const d = new Date(input);
  return isNaN(d.getTime()) ? null : d;
}

function partsInTZ(date) {
  const fmt = new Intl.DateTimeFormat("en-GB", {
    timeZone: TZ,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    weekday: "short",
    hour12: false,
  });
  const parts = fmt.formatToParts(date).reduce((acc, p) => {
    acc[p.type] = p.value;
    return acc;
  }, {});
  return parts;
}

export function formatDateLong(input) {
  const d = parseDate(input);
  if (!d) return "";
  const p = partsInTZ(d);
  // e.g. "12 de febrero de 2026"
  const day = parseInt(p.day, 10);
  const month = MONTHS[parseInt(p.month, 10) - 1];
  return `${day} de ${month} de ${p.year}`;
}

export function formatDateShort(input) {
  const d = parseDate(input);
  if (!d) return "";
  const p = partsInTZ(d);
  return `${p.day}/${p.month}/${p.year}`;
}

export function formatTime(input) {
  const d = parseDate(input);
  if (!d) return "";
  const p = partsInTZ(d);
  return `${p.hour}:${p.minute}`;
}

export function formatDateTime(input) {
  const d = parseDate(input);
  if (!d) return "";
  return `${formatDateLong(d)} · ${formatTime(d)} hs`;
}

export function formatDateWithWeekday(input) {
  const d = parseDate(input);
  if (!d) return "";
  // Use Intl for weekday name in Spanish, then format long date
  const weekday = new Intl.DateTimeFormat(LOCALE, {
    timeZone: TZ,
    weekday: "long",
  }).format(d);
  const long = formatDateLong(d);
  return `${weekday.charAt(0).toUpperCase() + weekday.slice(1)}, ${long}`;
}

export function relativeTime(input) {
  const d = parseDate(input);
  if (!d) return "";
  const now = new Date();
  const diffMs = now - d;
  const min = Math.floor(diffMs / 60000);
  if (min < 1) return "hace instantes";
  if (min < 60) return `hace ${min} min`;
  const h = Math.floor(min / 60);
  if (h < 24) return `hace ${h} h`;
  const days = Math.floor(h / 24);
  if (days < 7) return `hace ${days} d`;
  return formatDateShort(d);
}

export { TZ, LOCALE, WEEKDAYS, MONTHS };
